// extracted by mini-css-extract-plugin
module.exports = {"badge":"SuspendedProfileBadge_badge__nZcGM","label":"SuspendedProfileBadge_label__HIkGz"};